import { AuthenticationResultModel, LoginModel } from '../models';
import { ssoRequests } from './external/APIs';

const authenticate = async (
    credentials: LoginModel
): Promise<AuthenticationResultModel> => {
    const user = await ssoRequests.login(credentials);

    if (user.token) {
        localStorage.setItem('jwt', user.token);
        localStorage.setItem('user', JSON.stringify(user.user));
    }

    return user;
};

const logout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('jwt');
};

const authenticationService = {
    authenticate,
    logout,
};

export default authenticationService;
